var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":20,"width":2}}):_c('div',{staticClass:"caption font-weight-bold secondary--text mr-6"},[_vm._v("Rp. "+_vm._s(_vm._f("decimalformat")(_vm.balance)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }